import gql from "graphql-tag";
import ExecutiveCompensationHistoryItemFields from "lib/graphql/fragments/ExecutiveCompensationHistoryItemFields";
import MorningstarPersonFields from "lib/graphql/fragments/MorningstarPersonFields";

export default gql`
  query ExecutivesAndDirectors($tickerSymbol: TickerSymbol!, $country: SecurityCountry!) {
    issuerByTickerSymbol(tickerSymbol: $tickerSymbol, country: $country) {
      ... on AmericanCompanyIssuer {
        _id
        executivesAndDirectors {
          ...MorningstarPersonFields
          executiveCompensationHistoryInUSD: executiveCompensationHistory(currency: "USD") {
            ...ExecutiveCompensationHistoryItemFields
          }
          executiveCompensationHistoryInBRL: executiveCompensationHistory(currency: "BRL") {
            ...ExecutiveCompensationHistoryItemFields
          }
        }
      }
    }
  }

  ${MorningstarPersonFields}
  ${ExecutiveCompensationHistoryItemFields}
`;
